<div class="archer-pick" [class.is-picked]="picked()">
  <mat-checkbox [checked]="picked()" (change)="selectionToggle.emit()">
    {{ athlete().name }} · age {{ athlete().age }}
  </mat-checkbox>
  @if (picked() && showLane()) {
    <mat-form-field appearance="outline">
      <mat-label>Lane</mat-label>
      <input matInput type="number" min="1" [value]="laneNumber()" (input)="onLaneInput($event)" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Position</mat-label>
      <mat-select [value]="position()" (valueChange)="positionChange.emit($event)">
        @for (p of positions; track p) {
          <mat-option [value]="p">{{ positionLabel[p] }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>
